import { useState, useEffect } from "react";
import axios from "axios";
import { SubmitButton } from "../../components/Input";
import { useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../config";
import LoadingSpinner from "../../components/LoadingSpinner";
import { showToast } from "../../components/toast";
import StateManagedSelect from "react-select";

const TicketCategoryForm = () => {
  const [categoryName, setCategoryName] = useState("");
  const [assignUsers, setAssignUsers] = useState([]);
  const [userList, setUserList] = useState([]);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("authToken");
  const { id } = useParams();
  const navigate = useNavigate();

  const fetchTicketCategory = async (id) => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}category/add?id=${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      const category = response.data.data.category;
      setCategoryName(category.category_name);
      setAssignUsers(
        category.assign_user ? category.assign_user.split(",").map(Number) : []
      );
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchUserDropdown = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${API_URL}category/users/dropdown`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      setUserList(
        response.data.map((item) => ({
          value: item.id,
          label: item.name,
        }))
      );
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserDropdown();
    if (id) {
      fetchTicketCategory(id);
    }
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!categoryName) {
      showToast.success("Category name is required");
      return;
    }

    const payload = {
      id,
      category_name: categoryName,
      assign_user: assignUsers,
    };

    try {
      const response = await axios.post(
        `${API_URL}category/save?id=${id}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success === true) {
        showToast.success(response.data.message);
        navigate("/Ticket/Category");
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChangeCategoryName = (e) => {
    setCategoryName(e.target.value);
  };

  return (
    <div
      id="page-container"
      className="page-header-fixed page-sidebar-fixed fade in"
    >
      <div id="content">
        {loading && <LoadingSpinner />}
        <div className="panel panel-default with-rounded-corner with-shadow mt-3">
          <form>
            <div className="panel-heading border-0 mb-1">
              <span className="panel-title">Edit User</span>
            </div>
            <div className="panel-body">
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Category Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={categoryName}
                      onChange={handleChangeCategoryName}
                      placeholder="Enter Category Name"
                      disabled={id !== undefined}
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group">
                    <label>Assign User</label>
                    <StateManagedSelect
                      isMulti
                      options={userList}
                      value={userList.filter((user) =>
                        assignUsers.includes(user.value)
                      )}
                      onChange={(selectedOptions) =>
                        setAssignUsers(
                          selectedOptions.map((option) => option.value)
                        )
                      }
                    />
                  </div>
                </div>
              </div>

              <div className="form-group">
                <SubmitButton
                  pageBack={`/Ticket/Category`}
                  handleSubmit={handleSubmit}
                />
              </div>
            </div>
          </form>
        </div>
      </div>

      {/* Scroll to top button */}
      <a href="#" data-click="scroll-top" className="btn-scroll-top fade">
        <i className="ti-arrow-up"></i>
      </a>
    </div>
  );
};

export default TicketCategoryForm;
